import { LocalDateType } from '@app/models';
import { Calendar, CalendarDay, CalendarMonth } from '@app/pcs/models';
import * as R from 'ramda';

type GetMonths = (calendar: Calendar) => CalendarMonth[];
export const getMonths: GetMonths = R.prop('months');

type GetDaysOfMonth = (month: CalendarMonth) => CalendarDay[];
export const getDaysOfMonth: GetDaysOfMonth = R.prop('days');

type GetDayAt = (index: number, days: CalendarDay[]) => CalendarDay;
export const getDayAt: GetDayAt = R.nth;

type GetMonthAt = (index: number, months: CalendarMonth[]) => CalendarMonth;
export const getMonthAt: GetMonthAt = R.nth;

export const isSelectable: any = R.prop('selectable');
export const isNotSelectable = R.complement(isSelectable);
export const isSelected: any = R.prop('selected');
export const getDayValue = R.prop('dayValue');

export const setSelection = R.curry((selected: boolean, day: CalendarDay) =>
  isSelectable(day) ? R.mergeRight(day, {selected}) : day
);

export const toggleDaySelection = (day) => setSelection(!isSelected(day), day);

export const updateWeekDaysSelection = (calendar): Calendar => {
  const {weekdays} = calendar;

  const nextWeekdays = R.chain((day: any) => {
    const dayValue: any = getDayValue(day);
    const months = getMonths(calendar);
    const days = R.map(getDaysOfMonth, months);
    const isWeekDay: any = R.compose(R.equals(getDayValue(day)), getDayValue);
    const filteredDays: any = R.filter(R.allPass([isWeekDay, isSelectable]), R.flatten(days));
    const allDaysNotSelected = R.none(isSelected, filteredDays);

    const dayIndex = dayValue - 1;
    const dayFromStore = weekdays[dayIndex];

    return <any>R.mergeRight(dayFromStore, {selected: !allDaysNotSelected});
  }, weekdays);

  return R.mergeRight(calendar, {
    weekdays: nextWeekdays
  }) as Calendar;
};

export const getNextSelection = (months, filterDays = R.T) => {
  const days = R.map(getDaysOfMonth, months);
  const filteredDays = R.filter(filterDays, R.flatten(days));
  const allDaysSelected = R.all(R.anyPass([isSelected, isNotSelectable]), filteredDays);
  return !allDaysSelected;
};

export const findMonth = (date: LocalDateType, months: CalendarMonth[]) => R.find(month =>
  month.monthValue === date[1] && month.year === date[0],
months
);

export const isBetweenDays = (day: CalendarDay, startDay: number, endDay: number): boolean => {
  let start = startDay;
  let end = endDay;

  if (startDay > endDay) {
    start = endDay;
    end = startDay;
  }

  const beforeStartDay = day.index < start;
  const afterEndDay = day.index > end;
  return !(beforeStartDay || afterEndDay);
};

export const isAfterDay = (day, targetDay) => day.monthIndex > targetDay.monthIndex
    || (day.monthIndex === targetDay.monthIndex && day.dayIndex > targetDay.dayIndex);
